import { lazy } from 'react';

export default lazy(() =>
  import(/* webpackChunkName: 'viewer_page' */ './ViewerPage'),
);
